import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CLoadingButton,
  CRow,
} from '@coreui/react-pro'
import ReactQuill from 'react-quill'
import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import TeamService from 'src/service/TeamService'
import ToastComponent from 'src/components/common/TaostComponent'
import PreviewImage from '../PreviewImage'
const EditForm = (props) => {
  const API_URL = process.env.REACT_APP_API_URL
  const [playerDetail, setPlayerDetail] = useState()
  const [gradeName, setGradeName] = useState()
  useEffect(() => {
    if (props.selectedTeamId === props.teamId) {
      TeamService.getTeamDetail(props.teamId).then((res) => {
        if (res.status === 200) {
          setPlayerDetail(res.data)
          setGradeName(res.data.grade_name)
          setOwnerDetail(res?.data.owner_detail)
        }
      })
    }
  }, [props.selectedTeamId, props.teamId])

  const [loader, setLoader] = useState(false)
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required').max(50, '50 Character Limit is allowed.'),
  })
  const formik = useFormik({
    initialValues: {
      name: playerDetail?.name,
      team_owner: playerDetail?.team_owner,
      owner_detail: playerDetail?.owner_detail,
      grade_name: playerDetail?.gradeName,
      team_category: playerDetail?.team_category,
      team_type: playerDetail?.type,
      sponsor_link: playerDetail?.sponsor_link,
      image: null,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data, actions) => {
      var formData = new FormData()
      formData.append('teamId', props.teamId)
      formData.append('name', data.name)
      formData.append('grade_name', gradeName)
      formData.append('team_category', data.team_category)
      formData.append('team_type', data.team_type)
      formData.append('sponsor_link', data.sponsor_link)
      formData.append('image', data.image)
      formData.append('team_owner', data.team_owner)
      formData.append('owner_detail', ownerDetail)
      actions.resetForm({
        values: {
          name: '',
        },
      })
      setLoader(true)
      TeamService.editTeam(formData)
        .then((res) => {
          if (res.status === 200) {
            props.fetchUsers()
            props.toggleDetails(props.teamId)
            ToastComponent(res.message, 'success')
            setLoader(false)
          } else {
            setLoader(false)
            ToastComponent('something went wrong.', 'error')
          }
        })
        .catch((e) => {
          console.log(e)
          setLoader(false)
        })
    },
  })
  const gradeHandleChange = (e) => {
    setGradeName(e.target.value)
  }
  const quillRef = useRef()
  const [ownerDetail, setOwnerDetail] = useState()
  return (
    <>
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="first_name">
            Team Name
          </CFormLabel>
          <input
            type="text"
            name="name"
            className={
              'form-control' + (formik.errors.name && formik.touched.name ? ' is-invalid' : '')
            }
            id="name"
            placeholder="Name"
            defaultValue={playerDetail?.name}
            onChange={formik.handleChange}
          />
          {formik.errors.name && formik.touched.name && (
            <CFormFeedback invalid>{formik.errors.name}</CFormFeedback>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="grade_name">
            Comp This Team Plays In *
          </CFormLabel>
          <CFormSelect
            aria-label="Select Comp"
            name="grade_name"
            className={
              'form-control' +
              (formik.errors.grade_name && formik.touched.grade_name ? ' is-invalid' : '')
            }
            value={gradeName}
            onChange={gradeHandleChange}
            id="grade_name"
          >
            <option value={0}>Select comp</option>
            {props.gradeList &&
              props.gradeList.map((item, key) => (
                <option value={item?.id} key={key}>
                  {item?.grade} ({item?.sn})
                </option>
              ))}
          </CFormSelect>
          {formik.errors.grade_name && formik.touched.grade_name && (
            <CFormFeedback invalid>{formik.errors.grade_name}</CFormFeedback>
          )}
        </CCol>
        {/* <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="name">
            Team Type *
          </CFormLabel>
          <CFormSelect
            aria-label="Default select example"
            name="team_type"
            className={
              'form-control' +
              (formik.errors.team_type && formik.touched.team_type ? ' is-invalid' : '')
            }
            value={formik.values.team_type}
            onChange={formik.handleChange}
            id="team_type"
          >
            <option>Please Select Team Category</option>
            <option value="1">Senior Mens</option>
            <option value="2">Senior Womens</option>
            <option value="3">Veterans</option>
            <option value="4">Junior Boys</option>
            <option value="5">Junior Girls</option>
          </CFormSelect>
          {formik.errors.team_type && formik.touched.team_type && (
            <CFormFeedback invalid>{formik.errors.team_type}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="team_category">
            Team Category *
          </CFormLabel>
          <CFormSelect
            aria-label="Default select example"
            name="team_category"
            className={
              'form-control' +
              (formik.errors.team_category && formik.touched.team_category ? ' is-invalid' : '')
            }
            value={formik.values.team_category}
            onChange={formik.handleChange}
            id="team_category"
          >
            <option value={0}>Please select team category</option>
            {props.teamCategoryList &&
              props.teamCategoryList.map((item, key) => (
                <option value={item?.id} key={key}>
                  {item?.name}
                </option>
              ))}
          </CFormSelect>
          {formik.errors.team_category && formik.touched.team_category && (
            <CFormFeedback invalid>{formik.errors.team_category}</CFormFeedback>
          )}
        </CCol> */}
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="name">
            Team Sponsor Link
          </CFormLabel>
          <CFormInput
            placeholder="Team Sponsor Link"
            className={
              'form-control' +
              (formik.errors.sponsor_link && formik.touched.sponsor_link ? ' is-invalid' : '')
            }
            defaultValue={formik.values.sponsor_link}
            onChange={formik.handleChange}
            aria-label="sponsor_link"
            id="sponsor_link"
          />
          {formik.errors.sponsor_link && formik.touched.sponsor_link && (
            <CFormFeedback invalid>{formik.errors.sponsor_link}</CFormFeedback>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="name">
            Team Sponsor Logo
          </CFormLabel>
          <CFormInput
            type="file"
            id="formFile"
            name="image"
            className={
              formik.touched.image
                ? formik.errors.image
                  ? 'form-control input_user is-invalid'
                  : 'form-control input_user is-valid'
                : 'form-control'
            }
            onChange={(event) => {
              formik.setTouched({
                ...formik.touched,
                image: true,
              })
              formik.setFieldValue('image', event.target.files[0])
            }}
          />
          {formik.touched.image && formik.errors.image ? (
            <CFormFeedback invalid>{formik.errors.image}</CFormFeedback>
          ) : null}
          <CRow>
            <CCol md={2} className="d-flex align-items-center">
              {/* Show existing image only when a new file has NOT been selected */}
              {!formik?.values?.image &&
                (playerDetail?.image ? (
                  <img
                    src={`${API_URL}uploads/team_sponsor/${playerDetail.image}`}
                    alt="team_sponsor"
                    width="100"
                    height="100"
                  />
                ) : playerDetail?.game_logo ? (
                  <img
                    src={`${API_URL}uploads/game_logo/${playerDetail.game_logo}`}
                    alt="game_logo"
                    width="100"
                    height="100"
                  />
                ) : null)}

              {/* When user selects a new file, show preview instead of existing image */}
              {formik?.values?.image && (
                <PreviewImage
                  className="mx-auto"
                  width={100}
                  height={100}
                  file={formik.values.image}
                />
              )}
            </CCol>
          </CRow>
        </CCol>
        <CCol md={6}>
          <CFormLabel className="fw-bold" htmlFor="first_name">
            Team Owner
          </CFormLabel>
          <input
            type="text"
            name="team_owner"
            className={
              'form-control' +
              (formik.errors.team_owner && formik.touched.team_owner ? ' is-invalid' : '')
            }
            id="team_owner"
            placeholder="Team Owner"
            defaultValue={playerDetail?.team_owner}
            onChange={formik.handleChange}
          />
          {formik.errors.team_owner && formik.touched.team_owner && (
            <CFormFeedback invalid>{formik.errors.team_owner}</CFormFeedback>
          )}
        </CCol>
        <CCol md={6}>
          {' '}
          <CFormLabel className="fw-bold" htmlFor="name">
            Owner Details
          </CFormLabel>
          <ReactQuill
            theme="snow"
            ref={quillRef}
            value={ownerDetail}
            onChange={setOwnerDetail}
            // style={{ border: '1px solid' }}
          />
        </CCol>
        <CCol md={6}>
          <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
            Submit
          </CLoadingButton>
        </CCol>
      </CForm>
    </>
  )
}

export default EditForm
